import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { LanguageService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { loadFilteredLanguages } from '@store/actions/data.actions';
import { INoticeParams, Language, VacationReminderNoticeParams } from 'lingo2-models';
import { takeUntil } from 'rxjs/operators';
import { IBaseNotification } from '../../base-notification/base-notification.component';

@Component({
  selector: 'app-vacation-reminder',
  templateUrl: './vacation-reminder.component.html',
  styles: [''],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VacationReminderComponent extends ChangableComponent implements OnInit {
  public params: VacationReminderNoticeParams;
  public base: IBaseNotification;
  public langCode: string = 'en';

  @Input() set notification(notification: INoticeParams) {
    this.params = VacationReminderNoticeParams.createInstance(notification.params);
    this.base = {
      title: 'notifications.vacation_reminder.title',
      icon: 'notice-vacation',
      created_at: notification.created_at,
      modifier: null,
    };
  }

  constructor(protected readonly cdr: ChangeDetectorRef, private languageService: LanguageService) {
    super(cdr);
  }
  public ngOnInit() {
    this.languageService.language$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (language) => {
        this.langCode = language.code;
        this.detectChanges();
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
      },
    });
  }
}
